import Vue from 'vue';
import axios from 'axios';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, regex, confirmed } from 'vee-validate/dist/rules';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { LOADER_OPTIONS } from '@/constants';
import VueCardFormat from 'vue-credit-card-validation';
import * as VueGoogleMaps from 'vue2-google-maps';
import { GOOGLE_MAPS_KEY } from '@/constants';
import Vue2Filters from 'vue2-filters';
import VueGtm from 'vue-gtm';

import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import NowUIKit from './plugins/now-ui-kit';
import store from '@/store';
 
axios.interceptors.request.use(
  config => {
    return {
      ...config,
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        accessToken: store.state.accessToken
      }
    };
  },
  error => Promise.reject(error)
);

Vue.config.productionTip = false;
Vue.use(VueGtm, {
  id: 'GTM-MTVSMCL',
  defer: false,
  compatibility: false,
  enabled: true,
  vueRouter: router
});
Vue.use(PerfectScrollbar);
Vue.use(Loading, LOADER_OPTIONS);
Vue.use(VueCardFormat);
Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_MAPS_KEY
  }
});
Vue.use(Vue2Filters);
Vue.use(NowUIKit);

// vee-validation
extend('required', {
  ...required,
  message: '{_field_} is required'
});
extend('email', {
  ...email,
  message: '{_field_} is not valid'
});
extend('regex', {
  ...regex,
  message: '{_field_} is not valid'
});
extend('min', {
  validate(value, { min }) {
    return value.length >= min;
  },
  params: ['min'],
  message: '{_field_} field must be at least {min} characters'
});
extend('length', {
  validate(value, { length }) {
    return value.length === Number(length);
  },
  params: ['length'],
  message: '{_field_} field must be {length} digits'
});
extend('confirmed', {
  ...confirmed,
  message: '{_field_} doesn\'t match'
});
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Accept js
const acceptJs = document.createElement('script');
acceptJs.src = process.env.VUE_APP_ACCEPT_JS;
acceptJs.type = 'text/javascript';
acceptJs.setAttribute('charset', 'utf-8');
document.head.appendChild(acceptJs);

new Vue({
  router,
  render: h => h(App),
  store: store
}).$mount('#app');
